import { render, staticRenderFns } from "./confirmPopup.vue?vue&type=template&id=504a21e1&scoped=true"
import script from "./confirmPopup.vue?vue&type=script&lang=js"
export * from "./confirmPopup.vue?vue&type=script&lang=js"
import style0 from "./confirmPopup.vue?vue&type=style&index=0&id=504a21e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a21e1",
  null
  
)

export default component.exports